import VirtualTourRightPart from '../../../components/VirtualTourPage/VirtualTourRightPart/VirtualTourRightPart';

import withDefaultProps from './withDefaultProps';

export default withDefaultProps(VirtualTourRightPart);
